module.exports = __webpack_public_path__ + "img/close.b98437ef.svg";